import { getMealDealApi } from "../../api/home/mealDealApi";
import {
  GET_MEALDEAL_SUCCESS,
  GET_MEALDEAL_FAILURE,
} from "../types";

export const getMealDealSuccess = (homepage) => ({
  type: GET_MEALDEAL_SUCCESS,
  payload: homepage,
});

export const getMealDealFailure = (error) => ({
  type: GET_MEALDEAL_FAILURE,
  payload: error,
});

export const getMealDeal = (postData) => {
  return (dispatch) => {
    getMealDealApi(postData)
      .then((response) => {
        dispatch(getMealDealSuccess(response.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(getMealDealFailure(error.message));
      });
  };
};
